import React from 'react';
import { FolderOpen, Globe2, Phone, ExternalLink } from 'lucide-react';
import { SYSTEM_COLORS } from '../../../constants/brandPalette';
import { getInitials, getAvatarColor, fmt, statusCls, statusLabel } from './clientHelpers';

const ClientCard = ({ client, onClick }) => {
  const projectCount = client.project_ids?.length ?? 0;

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onClick()}
      className="bg-white rounded-2xl border cursor-pointer transition-all duration-150 hover:shadow-md hover:-translate-y-0.5 group overflow-hidden"
      style={{ borderColor: SYSTEM_COLORS.borderSoft }}
    >
      {/* Accent bar */}
      <div className="w-full h-1" style={{ backgroundColor: getAvatarColor(client.organization || client.name) }} />

      <div className="p-4 space-y-3 sm:p-5">
        {/* Top row */}
        <div className="flex items-start gap-3">
          <div
            className="flex items-center justify-center flex-shrink-0 w-10 h-10 text-sm font-bold text-white rounded-xl"
            style={{ backgroundColor: getAvatarColor(client.organization || client.name) }}
          >
            {getInitials(client.organization || client.name)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 truncate group-hover:text-[#37559e] transition-colors">
              {client.organization || '—'}
            </p>
            <p className="text-xs text-gray-500 truncate">{client.name}</p>
          </div>
          <span className={`flex-shrink-0 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${statusCls(client.status)}`}>
            {statusLabel(client.status)}
          </span>
        </div>

        {/* Meta */}
        <div className="space-y-1.5 text-xs text-gray-500">
          {client.email && (
            <div className="flex items-center gap-1.5 truncate">
              <ExternalLink size={11} className="flex-shrink-0 text-gray-400" />
              <span className="truncate">{client.email}</span>
            </div>
          )}
          {client.industry && (
            <div className="flex items-center gap-1.5">
              <Globe2 size={11} className="flex-shrink-0 text-gray-400" />
              <span>{client.industry}</span>
            </div>
          )}
          {client.contact_phone && (
            <div className="flex items-center gap-1.5">
              <Phone size={11} className="flex-shrink-0 text-gray-400" />
              <span>{client.contact_phone}</span>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-2 border-t" style={{ borderColor: SYSTEM_COLORS.borderSoft }}>
          <span className="flex items-center gap-1.5 text-xs text-gray-500">
            <FolderOpen size={11} className="text-gray-400" />
            {projectCount} project{projectCount !== 1 ? 's' : ''}
          </span>
          <span className="text-[10px] text-gray-400">{fmt(client.created_at)}</span>
        </div>
      </div>
    </div>
  );
};

export default ClientCard;
